/**
 * Re-export shim for BookingModal icons.
 *
 * Canonical icon definitions live under `apps/landing/src/components/icons/`.
 * This file is preserved so the existing `BookingModal.{tsx,form.tsx,success.tsx}`
 * imports keep working without churn.
 */

export { CalendarIcon } from '@/components/icons/CalendarIcon';
export { MailIcon } from '@/components/icons/MailIcon';
export { MessageIcon } from '@/components/icons/MessageIcon';
export { UserIcon } from '@/components/icons/UserIcon';
export { LoadingSpinner } from '@/components/icons/LoadingSpinner';
